import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import { msalConfig } from './authConfig';
import MainApp from './MainApp';

// Inicializar MSAL
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        // Aguardar a inicialização do MSAL
        await msalInstance.initialize();

        // Processar redirecionamento após inicialização
        const response = await msalInstance.handleRedirectPromise();

        if (response) {
          // Login realizado com sucesso
        }

        // Verificar se há contas e definir a primeira como ativa
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          const activeAccount = msalInstance.getActiveAccount();
          if (!activeAccount) {
            msalInstance.setActiveAccount(accounts[0]);
          }
        }

        setIsInitialized(true);
      } catch (error) {
        // Mesmo com erro, vamos continuar para não travar a aplicação
        setIsInitialized(true);
      }
    };

    initializeMsal();
  }, []);

  if (!isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{ color: 'white', textAlign: 'center' }}>
          <h2>Carregando...</h2>
          <p>Inicializando autenticação</p>
        </div>
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <MainApp />
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
